import React from 'react';
import { Clock3, TrendingUp } from 'lucide-react';

function TrendingTopics({
  recentSearches = [],
  trendingSearches = [],
  onSearchSubmit,
}) {
  if (recentSearches.length === 0 && trendingSearches.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2">
      {recentSearches.length > 0 ? (
        <div className="flex flex-wrap items-center gap-2">
          <span className="inline-flex items-center gap-1 text-xs text-primary-content/80">
            <Clock3 className="h-3.5 w-3.5" aria-hidden="true" />
            Recent
          </span>
          {recentSearches.map((term) => (
            <button
              key={`recent-${term}`}
              type="button"
              className="rounded-lg border border-white/35 bg-white/85 px-2.5 py-0.5 text-xs font-medium text-slate-700 transition hover:bg-white"
              onClick={() => onSearchSubmit?.(term)}
            >
              {term}
            </button>
          ))}
        </div>
      ) : null}

      {trendingSearches.length > 0 ? (
        <div className="flex flex-wrap items-center gap-2">
          <span className="inline-flex items-center gap-1 text-xs text-primary-content/80">
            <TrendingUp className="h-3.5 w-3.5" aria-hidden="true" />
            Trending
          </span>
          {trendingSearches.map((term) => (
            <button
              key={`trend-${term}`}
              type="button"
              className="rounded-lg border border-white/35 bg-white/85 px-2.5 py-0.5 text-xs font-medium text-slate-700 transition hover:bg-white"
              onClick={() => onSearchSubmit?.(term)}
            >
              {term}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}

export default TrendingTopics;
